"use strict";

exports.__esModule = true;
var _PlantInfoLoader = require("./PlantInfoLoader");
Object.keys(_PlantInfoLoader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PlantInfoLoader[key]) return;
  exports[key] = _PlantInfoLoader[key];
});
var _PlantInfo = require("./PlantInfo");
Object.keys(_PlantInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PlantInfo[key]) return;
  exports[key] = _PlantInfo[key];
});